import React, { useCallback, useEffect, useLayoutEffect } from 'react'
import { Text } from 'react-native-paper'
import Layout from '../Layout'
import BackButton from '../BackButton'
import Spacer from '../../../ui/atoms/Spacer'
import OtpInput from '../../../ui/atoms/OtpInput'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import SignupStore from '../stores/SignupStore'
import { observer } from 'mobx-react'
import { dispatcher, pathFactory, paths } from '../../links'
import { useTranslation } from 'react-i18next'
import SubmitButton from '../SubmitButton'
import { AlreadyHaveAcc } from '../AlreadyHaveAcc'
import { ErrorMessage } from '../ErrorMessage'
import { SubTitle } from '../Title'
import { Link } from '../../../ui/atoms/Link'
import useRecaptcha from '../useRecaptcha'
import TermsAndConditions from '../TermsAndConditions'
import RootStore from '../../../store'
import { useResponsive } from '../../../utils/hooks'

export default observer(
  ({ navigation, onContinue, dontNavigate, route, onBack }) => {
    const {
      password,
      canSubmit,
      setPassword,
      verifyPhone,
      login,
      errors,
      canContinueSignup,
      removeError,
    } = SignupStore

    const recaptcha = useRecaptcha('signup')
    const { sm } = useResponsive()

    useEffect(() => {
      if (route?.params) RootStore.initRouteParams(route?.params)
    }, [route?.params])

    useEffect(() => {
      recaptcha.createVerifier()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const resendSmsCode = useCallback(async () => {
      SignupStore.checkUserSignUp(recaptcha.verifier).catch((e) =>
        console.log(e),
      )
    }, [recaptcha.verifier])

    const { t } = useTranslation('auth')
    useLayoutEffect(() => {
      if (!canSubmit) {
        navigation.replace(paths.Auth.SignUp)
      }
    }, [canSubmit, navigation])
    useEffect(() => {
      if (password.length === 6) {
        const timer = setTimeout(() => {
          clearTimeout(timer)
          SignupStore.setCodeVerifier(false)
        }, 60000)
        verifyPhone()
          .then(() => {
            clearTimeout(timer)
            return onContinue
              ? onContinue()
              : navigation.navigate(paths.Auth.SignUpForm)
          })
          .catch((e) => console.log(e))
      }
    }, [navigation, onContinue, password, verifyPhone])

    const onOtpChange = (val) => {
      setPassword(val)
      errors.get('verify') && removeError('verify')
    }

    const onBackPress = () => {
      if (onBack) {
        onBack()
      } else {
        const action = dispatcher(pathFactory('Auth.SignUp'))
        navigation.replace(action.name, action.params)
      }
    }
    return (
      <Layout onBackPress={onBackPress}>
        <BackButton onPress={onBackPress} />
        <Text
          style={{
            fontSize: 32,
            fontWeight: '600',
            marginBottom: 10,
            textAlign: sm ? undefined : 'center',
          }}
        >
          {t('codeTitle')}
        </Text>
        <Spacer height={16} />
        <SubTitle>
          {t('codeSubTitle')}
          <Text style={{ color: commonColors.accentText }}>
            ****{login.slice(-4)}
          </Text>
        </SubTitle>
        <Spacer height={40} />
        <OtpInput otp={password} onChange={onOtpChange} />
        <Spacer />
        <ErrorMessage error={errors.get('verify')?.message} />
        <Spacer height={20} />
        <Text
          style={{
            fontSize: 14,
            color: commonColors.textLight,
            lineHeight: 20,
            textAlign: sm ? undefined : 'center',
          }}
        >
          {t('codeQuestion')}
          <Link
            title={t('resendCode')}
            color="#00A0F3"
            onPress={resendSmsCode}
          />
        </Text>
        <Spacer height={40} />
        {dontNavigate && <TermsAndConditions />}
        <SubmitButton
          onPress={() =>
            onContinue
              ? onContinue()
              : navigation.navigate(paths.Auth.SignUpForm)
          }
          disabled={!canContinueSignup}
          loading={RootStore.isBusy}
        >
          {dontNavigate ? t('signUp.submitLabel2') : t('signUp.submitLabel')}
        </SubmitButton>
        <Spacer height={40} />

        <AlreadyHaveAcc navigation={navigation} dontNavigate={dontNavigate} />
      </Layout>
    )
  },
)
